<template>
  <span class="flex items-center paragraph-bold mr-300">
    <LcIcon class="mr-100" name="language" size="medium" />
    <p>{{ $t('locale') }}</p>
  </span>

  <ListSelect
    v-model="options"
    :class="{ 'discreet-list': variant === 'discreet' }"
    :custom-component="SwitchLocalePathLink"
    horizontal
    size="small"
    :variant="variant"
    @option-click="onOptionClick"
  />
</template>

<script lang="ts" setup>
import { SwitchLocalePathLink } from '#components'

import type { ListSelectOption } from '~/components/ListSelect/ListSelect.vue'

type LanguageSwitchEmit = {
  (event: 'optionClick', value: ListSelectOption): void
}

type LanguageSwitchProps = {
  variant?: 'discreet'
}

const emit = defineEmits<LanguageSwitchEmit>()

defineProps<LanguageSwitchProps>()

const { options } = useLanguageUtils()
const { setLocale } = useI18n()
const { getSafeLocale } = useLocaleUtils()

const onOptionClick = async (newOption: ListSelectOption) => {
  const newLocale = getSafeLocale(newOption.value)
  await setLocale(newLocale)

  emit('optionClick', newOption)
}
</script>

<style scoped lang="scss">
:deep(.discreet-list) {
  flex-grow: 1;

  & li {
    flex-grow: 1;
    max-width: 9.625rem;
  }
}
</style>
